import { FunctionComponent } from "react";
import { StyledH1Title, StyledH2Title } from "./title.styles";

interface TitleProps {
  children: any;
  className?: string;
  level?: "h1" | "h2";
}

const Title: FunctionComponent<TitleProps> = ({
  children,
  className,
  level = "h1",
}) => {
  switch (level) {
    case "h1":
      return <StyledH1Title className={className}>{children}</StyledH1Title>;
    case "h2":
      return (
        <StyledH2Title as="h2" className={className}>
          {children}
        </StyledH2Title>
      );
  }
};

export default Title;
